import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { accountService } from '../_services';
import { toast } from "../_components/Toast";
import { config } from '../_helpers';

function ResetPassword(props) {
    const TokenStatus = {
        Validating: 'Validating',
        Valid: 'Valid',
        Invalid: 'Invalid'
    }
    const token = sessionStorage.getItem("jwtToken");
    const tokenStatus = 'Valid';

    function getForm() {
        const initialValues = {
            password: '',
            confirmPassword: ''
        };

        const validationSchema = Yup.object().shape({
            password: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm Password is required'),
        });

        function onSubmit({ password, confirmPassword }, { setSubmitting }) {
            // toast.clear();
            accountService.resetPassword({ token, password, confirmPassword, user: props.user })
                .then(() => {
                    toast.success('Password reset successful!', { keepAfterRouteChange: true });
                    props.closeModal && props.closeModal();
                })
                .catch(error => {
                    setSubmitting(false);
                    toast.error(error);
                });
        }

        return (
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                {({ errors, touched, isSubmitting }) => (
                    <Form>
                        {props.user && (
                            <div className="mb-4 text-center" style={{ color: "#05076bff" }}>
                                <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#065380ff" }}>
                                    {props.user.firstName} {props.user.lastName}
                                </div>
                                <div style={{ fontSize: "0.9em", opacity: 0.8 }}>
                                    {props.user.email}
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label>New Password</label>
                            <Field
                                name="password"
                                type="password"
                                className={`form-control ${errors.password && touched.password ? 'is-invalid' : ''}`}
                                placeholder="New Password"
                            />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                        </div>

                        <div className="form-group">
                            <label>Confirm Password</label>
                            <Field
                                name="confirmPassword"
                                type="password"
                                className={`form-control ${errors.confirmPassword && touched.confirmPassword ? 'is-invalid' : ''}`}
                                placeholder="Confirm Password"
                            />
                            <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                        </div>

                        <div className="form-group d-flex justify-content-end mt-3">
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary w-100">
                                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                Reset Password
                            </button>
                        </div>

                        {!props.closeModal && (
                            <div className="form-group d-flex justify-content-center align-items-center mt-4">
                                <Link to="login" className="btn btn-link p-0">
                                    Back to Sign In
                                </Link>
                            </div>
                        )}

                        <div style={{ fontSize: "0.7em", color: "#666", textAlign: "center", marginTop: "30px" }}>
                            <span>&#169;</span>{new Date().getFullYear() + " " + config.Provider}. All Rights Reserved.
                        </div>
                    </Form>
                )}
            </Formik>
        );
    }

    function getBody() {
        switch (tokenStatus) {
            case TokenStatus.Valid:
                return getForm();
            case TokenStatus.Invalid:
                return (
                    <div className="text-center py-4">
                        <div className="text-danger mb-3" style={{ fontSize: "3rem" }}>
                            <i className="bi bi-exclamation-triangle"></i>
                        </div>
                        <p style={{ color: "#ccc" }}>Token validation failed. If the token has expired, you can get a new one at the <Link to="forgot-password">forgot password</Link> page.</p>
                    </div>
                );
            case TokenStatus.Validating:
                return (
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary mb-3" role="status"></div>
                        <p style={{ color: "#ccc" }}>Validating token...</p>
                    </div>
                );
            default:
                return null;
        }
    }

    return getBody();
}

export { ResetPassword };